import { StoreInfoSectionProps } from "@repo/core/components/receipt/sections/StoreInfoSection/types";

export const storeInfoMock: StoreInfoSectionProps = {
  title: "Destino",
  icon: "circle-arrow-down",
  name: "Mobly Comércio Varejista Ltda",
  cnpj: "97.506.444/0004-90",
  phone: "(11) 3339-0609",
  address: "Av. João Pinto",
  nsuTerminal: "10501",
  nsuProcessor: "1922619",
  date: "11/03/2024",
  time: "15:03:40"
};
